import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { SIZE } from '../../../constants/size'
import { getEntityActionTypeSelectOptionsEditOnly } from '../../Entity'
import { FormModal } from '../../Form'

import { FormFields } from './FormFields'
import { QA_NAME_EDIT_TYPE_MODAL } from './TaskEditTypeModal.constants'
import {
  getTaskEditTypePayload,
  getTaskEditTypeValidationSchema,
} from './TaskEditTypeModal.utils'

function TaskEditTypeModal({
  formFieldsProps: {
    actionTypes = getEntityActionTypeSelectOptionsEditOnly(),
    ...formFieldsProps
  } = EMPTY_OBJECT,
  getPayload = getTaskEditTypePayload,
  getValidationSchema = getTaskEditTypeValidationSchema,
  initialValues,
  onSubmit,
  ...restProps
}) {
  const { t } = useTranslation()

  const validationSchema = getValidationSchema(t)

  const formBodyProps = {
    withNotifications: true,
  }

  function handleSubmit({ values }) {
    onSubmit({
      payload: getPayload(values),
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_EDIT_TYPE_MODAL,
      }}
      formBodyProps={formBodyProps}
      formFieldsProps={{ ...formFieldsProps, actionTypes }}
      formTitle='Task.EditTypeModalTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default TaskEditTypeModal
